var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline ml-2"},[_vm._v(" "+_vm._s(this.min)+":"+_vm._s(this.sec)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }